import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { ReportRequestDTO } from '../models/ReportRequestDTO';
import { AuthService } from './auth/auth.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class EmailService {

  myHeader: Headers;

  constructor(private authHttp: AuthHttp, private auth:AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('Email service Initialized...');
  }

  sendEmail(InvNumber: string, CreditNumber: string, ToEmail: string, CCEmail: string, ActionName: string, EmailComments:
    string, DocType: string) {

    const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, ToEmail, CCEmail, ActionName, EmailComments);
    request.DocumentType = DocType;
    return this.authHttp.post(`/api/Report/GeneratePdf`, request, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GeneratePdf has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getPdfFile(InvNumber: string, CreditNumber: string, contractNumber: string, ActionName: string, DocType: string) {

    // const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, ToEmail, CCEmail, ActionName, EmailComments);

    const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, '', '', ActionName, '');

    request.ContractNumber = contractNumber;
    request.AssetType = ActionName; // only for  contract 'JSSI0035891'
    request.DocumentType = DocType;

    return this.authHttp.post(`/api/Report/GeneratePdfLocally`, request, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GeneratePdf has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });

  }
  getStmtPdfFile(contractNumber: string) {

        // const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, ToEmail, CCEmail, ActionName, EmailComments);

        const request: ReportRequestDTO = new ReportRequestDTO('', '', '', '', '', '');

        request.ContractNumber = contractNumber;
        request.StmtFileName = 'RMStatementRevised';

        return this.authHttp.post(`/api/Report/GeneratePdfLocally`, request, { headers: this.myHeader }).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('GeneratePdf has failed ' + res.status);
          } else {
            return res.json();
          }
        });

      }

      getAccountStmtPdfFile(contractNumber: string, stmtfilename: string) {

        // const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, ToEmail, CCEmail, ActionName, EmailComments);

        const request: ReportRequestDTO = new ReportRequestDTO('', '', '', '', '', '');

        request.ContractNumber = contractNumber;
        request.StmtFileName = stmtfilename;

        return this.authHttp.post(`/api/Report/GeneratePdfLocally`, request, { headers: this.myHeader }).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('GeneratePdf has failed ' + res.status);
          } else {
            return res.json();
          }
        });

      }

  getPOPdfFile(poNumber: string) {

        // const request: ReportRequestDTO = new ReportRequestDTO(InvNumber, CreditNumber, ToEmail, CCEmail, ActionName, EmailComments);

        const request: ReportRequestDTO = new ReportRequestDTO('', '', '', '', '', '');

        request.PONumber = poNumber;

        return this.authHttp.post(`/api/Report/GeneratePOPdfLocally`, request, { headers: this.myHeader }).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('GeneratePdf has failed ' + res.status);
          } else {
            return res.json();
          }
        });

      }
      ExportReportToPDF(documentNo:string,DocumentType:string,ContractNumber:string, AssetType:string) {
        const request: ReportRequestDTO =  new ReportRequestDTO('', '', '', '', '', '');
        request.InvNumber=documentNo;
        request.DocumentType=DocumentType;
        request.AssetType=AssetType;
        request.ContractNumber=ContractNumber;
        return this.authHttp.post(`/api/Report/ExportReportToPDF`,request, { headers: this.myHeader }).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('GeneratePdf has failed ' + res.status);
          } else {
            return res.json();
          }
        });
      }



}





// WEBPACK FOOTER //
// ./src/app/services/email.service.ts